import {
	OrgHeaderButton,
	OrgHeaderButtonMenuItem,
} from "./app-bar-components/OrgHeaderButton";
import { useState } from "react";
import {
	LogOut,
	User,
	Keyboard,
	Braces,
	LifeBuoy,
	Table,
	Truck,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { isDeveloper } from "@/lib/utils/is-app-user";
import { TableSettingsDialog } from "@/dentlab/src/pages-via-dialog/table-settings/table-settings.dialog";
import { KeyboardShortcutsDialog } from "@/dentlab/src/components/keyboard-shortcuts-dialog";
import { getLocalStorage, setLocalStorage } from "@/lib/utils/local-storage";

interface DlOrgHeaderButtonProps {
	orgName: string;
	orgFirstLetter: string;
	isExpanded: boolean;
	isPinned: boolean;
}

export const DlOrgHeaderButton: React.FC<DlOrgHeaderButtonProps> = ({
	orgName,
	orgFirstLetter,
	isExpanded,
	isPinned,
}) => {
	const navigate = useNavigate();
	const { userEmail } = useCentralStore((state) => ({
		userEmail: state.userEmail,
	}));
	const handleSignOut = useCentralStore((state) => state.handleSignOut);
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [isTableSettingsOpen, setIsTableSettingsOpen] = useState(false);
	const [isShortcutsOpen, setIsShortcutsOpen] = useState(false);

	const handleMenuItemClick = (path: string) => {
		navigate(path);
		setIsMenuOpen(false);
	};

	const handleSignOutClick = () => {
		handleSignOut();
		setIsMenuOpen(false);
	};

	return (
		<>
			<TableSettingsDialog
				open={isTableSettingsOpen}
				onClose={() => setIsTableSettingsOpen(false)}
			/>
			<KeyboardShortcutsDialog
				open={isShortcutsOpen}
				onClose={() => setIsShortcutsOpen(false)}
			/>
			<OrgHeaderButton
				name={orgName}
				letter={orgFirstLetter}
				isExpanded={isExpanded || isPinned}
				isPinned={isPinned}
				isMenuOpen={isMenuOpen}
				setIsMenuOpen={setIsMenuOpen}
			>
				<OrgHeaderButtonMenuItem
					icon={<Keyboard className="h-4 w-4" />}
					label="Tastenkürzel"
					onClick={() => setIsShortcutsOpen(true)}
				/>
				<OrgHeaderButtonMenuItem
					icon={<User className="h-4 w-4" />}
					label="Kontoeinstellungen"
					onClick={() => handleMenuItemClick("/account-settings")}
				/>
				<OrgHeaderButtonMenuItem
					icon={<Table className="h-4 w-4" />}
					label="Tabelleneinstellungen"
					onClick={() => {
						setIsTableSettingsOpen(true);
						setIsMenuOpen(false);
					}}
				/>
				{(window.location.hostname.includes("localhost") ||
					isDeveloper(import.meta.env, userEmail)) && (
					<>
						<OrgHeaderButtonMenuItem
							icon={<Braces className="h-4 w-4" />}
							label="Entwickler-Infos"
							onClick={() => {
								setLocalStorage(
									"showIdInfo",
									!getLocalStorage("showIdInfo", false)
								);
								window.location.reload();
							}}
						/>
						<OrgHeaderButtonMenuItem
							icon={<LifeBuoy className="h-4 w-4" />}
							label="Support"
							onClick={() => handleMenuItemClick("/support")}
						/>
					</>
				)}
				<OrgHeaderButtonMenuItem
					icon={<Truck className="h-4 w-4" />}
					label="Lieferungen"
					onClick={() => handleMenuItemClick("/lieferungen")}
				/>
				<OrgHeaderButtonMenuItem
					icon={<LogOut className="h-4 w-4" />}
					label="Logout"
					onClick={handleSignOutClick}
				/>
			</OrgHeaderButton>
		</>
	);
};
